import { render, staticRenderFns } from "./ClientService.vue?vue&type=template&id=7d62e7f8"
import script from "./ClientService.vue?vue&type=script&lang=js"
export * from "./ClientService.vue?vue&type=script&lang=js"
import style0 from "./ClientService.vue?vue&type=style&index=0&id=7d62e7f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports